import { Button } from "@mui/material";
import type { FC } from "react";
import { ActivityGroupRows } from "web_myplann/Activities/Components/ActivityGroupRows";
import type { ActivityOrTaskListItem } from "web_myplann/Activities/Helpers/isActivityListItem";
import { DashboardSection } from "web_myplann/Dashboard/Components/DashboardSection";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EventRowVariant } from "web_myplann/Shared/Types/EventRowVariant";

type Props = {
	title: string;
	items: ActivityOrTaskListItem[];
	onShowAll: () => void;
};

export const DashboardEventSection: FC<Props> = ({
	title,
	items,
	onShowAll,
}) => {
	const { t } = useResource();

	return (
		items.length > 0 && (
			<DashboardSection title={title}>
				<ActivityGroupRows
					items={items}
					showPerson={false}
					variant={EventRowVariant.Preview}
				/>
				<Button variant="showAll" onClick={onShowAll}>
					{t(Resources.Dashboard.ShowAllButton.title)} →
				</Button>
			</DashboardSection>
		)
	);
};
